import styled from 'styled-components';

export const StyledDatePickerPopoverWrapper = styled.div`
    .elmo-popover {
        display: block;
        &__target {
            & > div {
                position: relative;

                .elmo-input {
                    background-color: #fff;
                }

                .btn-clear {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    bottom: 6px;
                    z-index: 2;
                    display: block;
                    border: none;
                    background-color: transparent;
                    cursor: pointer;

                    &:focus,
                    &:hover {
                        outline: none;
                    }
                }
            }
        }
    }
`;
